import React from 'react';
import { StyleSheet, View, ActivityIndicator } from 'react-native';
import Icon from '../Icon';
import { Color, CommonProperties } from '../../styles';
import Modal from '../Modal';
import BaseText from '../BaseText';
import { scale } from '../../utils/scale.utils';

const LoaderOverlay = ({ icon, loadingText }) => {
  return (
    <Modal animationType="fade" statusBarTranslucent={false} transparent={true} visible={true}>
      <View style={styles.darkTransparent}>
        {icon && (
          <View style={styles.modalView}>
            <Icon name={icon} size={100} color={Color.primary} />
          </View>
        )}
        {!icon && <ActivityIndicator />}
        {loadingText && (
          <View>
            <BaseText style={styles.textStyle}>{loadingText}</BaseText>
          </View>
        )}
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  darkTransparent: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,.4)',
    ...CommonProperties.centerAlignment,
  },
  modalView: {
    borderRadius: scale(70),
    width: scale(140),
    height: scale(140),
    backgroundColor: 'white',
    ...CommonProperties.centerAlignment,
  },
  textStyle: {
    color: 'white',
    textAlign: 'center',
    ...CommonProperties.h2,
    ...CommonProperties.mt3,
  },
});

export default LoaderOverlay;
